export interface GettextTranslateOptions {
  msgid: string;
  n?: number;
  context?: string;
  plural?: string;
  language?: string;
  args?: Record<string, any>;
  conversion?: string | string[];
}

export enum GettextKind {
  invalid = 0,
  gettext = 1,
  ngettext,
  pgettext,
  npgettext,
}

export interface ParseGettextExpressionResult {
  valid: boolean;
  kind: GettextKind;
  msgid: string;
  n?: number | string;
  context?: string;
  plural?: string;
}
